<template>
<div class="user-register_urr">

  <page-header>
    <nav-inner :links="[
        { url: '/user/authenticate', text: 'Войти', activeRegexp: '/user/authenticate' },
        { url: '/user/register', text: 'Регистрация', activeRegexp: '/user/register' },
      ]"/>
  </page-header>

  <div class="page-container_pcr">
    <router-link
      class="help-link"
      style="text-align: center;"
      :to="{ path: '/help/2'}"
      target="_blank">
      Подробнее о регистрации в разделе Помощь
    </router-link>

    <app-inputs ref="inputs">

      <div class="block-wrap block-wrap_error" v-if="error.length">
        <div
          v-for="(e, i) in error"
          :key="`error-${i}`"
          class="block-wrap-error">
          {{ e }}
        </div>
      </div>

      <!--<div class="urr_registration-notice">
        <i class="el-icon-warning"></i>
        Регистрация пользователей на данный момент доступна только для участников проекта.
      </div>-->

      <div class="block-wrap">
        <app-input
          widget="AppMailComplex"
          :options="{ name: 'mail', title: 'E-mail', required: true,
            unique: true, verify: true }"/>
        <div class="input-notice text-center">
          Данный e-mail будет использоваться для входа на сайт.
            Процедура подтверждения обязательна.</div>
      </div>

      <!--<div class="block-wrap">
        <app-input
          widget="AppPhone"
          :options="{ name: 'phone', title: 'Номер телефона' }"/>
      </div>-->

      <div class="block-wrap">
        <app-input
          widget="AppText"
          :options="{ name: 'phone', title: 'Номер телефона' }"/>
      </div>

      <div class="block-wrap">
        <app-input
          widget="AppFio"
          :options="{ name: 'fio', title: 'Ф.И.О.', required: true }"/>
      </div>

      <div class="block-wrap">
        <app-input
          widget="AppSelect"
          :options="{ name: 'academicDegree', title: 'Ученые степени',
            multiple: true, options: academicDegrees }"/>
      </div>

      <div class="block-wrap">
        <app-input
          widget="AppSelect"
          :options="{ name: 'academicTitle', title: 'Учёное звание', options: academicTitles }"/>
      </div>

      <div class="block-wrap">
        <app-input
            widget="AppPassword"
            :options="{ name: 'password', title: 'Пароль', required: true,
            confirm: true, strength: true }"/>
      </div>

      <div class="block-wrap">
        <app-input
          widget="AppJob"
          :options="{ name: 'job', title: 'Место работы', multiple: true }"/>
      </div>

      <div class="block-wrap">
        <app-input
          widget="AppUserAgreement"
          :options="{ name: 'userAgreement', required: true }"/>
      </div>

      <div class="block-wrap">
        <div class="buttons-wrap">
          <button class="vivid-button" @click="submit">Зарегистрироваться</button>
        </div>
      </div>

    </app-inputs>

  </div>

  <page-footer/>

</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import Misc from '../../mixins/Misc';
import academicTitles from '../../data/academic-titles';
import academicDegrees from '../../data/academic-degrees';
import AppInput from '../inputs/AppInput';
import AppInputs from '../inputs/AppInputs';

export default {

  mixins: [Misc],

  components: { PageHeader, PageFooter, NavInner, AppInput, AppInputs },

  data() {
    return {
      error: [],
      academicTitles,
      academicDegrees,
    };
  },

  mounted() {
    const script = document.createElement('script');
    script.setAttribute('src', '/static/js/jsrsasign-all-min.js');
    document.head.appendChild(script);
  },

  watch: {
    isAuthenticated() {
      if (this.isAuthenticated) {
        this.redirectAuthenticatedUser();
      }
    },
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated'];
    },
  },

  methods: {

    submit() {
      this.scrollTop();
      if (!this.$refs.inputs.hasErrors()) {
        Vue.$loading.on();
        setTimeout(() => {
          const values = this.$refs.inputs.getValues();
          const keysPair = window.GenerateKeysPair(values.password.password);
          values.privateKey = keysPair[0];
          values.publicKey = keysPair[1];
          axios.post('users', JSON.stringify(values))
            .then(() => {
              Vue.$loading.off();
              const credentials = {
                mail: values.mail.mail,
                password: values.password.password,
              };
              this.$store.dispatch('user/authenticate', credentials);
            })
            .catch((error) => {
              Vue.$loading.off();
              let respError = error.response.data;
              this.$message.closeAll();
              if (Array.isArray(respError) && respError.length) {
                respError = respError[0];
              }
              this.$message({
                type: 'error',
                message: respError,
                duration: 6000,
              });
            });
        }, 1500);
      } else {
        this.$message('Исправьте ошибки в указанных полях.');
      }
    },

    redirectAuthenticatedUser() {
      this.$router.replace({ path: '/' });
    },

  },

};
</script>

<style lang="scss">
.user-register_urr {
  margin-bottom: 90px;
  .block-wrap {
    max-width: 700px;
  }
  .urr_registration-notice {
    color: #fff;
    opacity: .7;
    font-weight: 300;
    max-width: 450px;
    font-size: 16px;
    text-align: center;
    line-height: 22px;
    margin: 0 auto 20px;
    position: relative;
    i {
      top: 3px;
      opacity: .5;
      margin-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserRegister.vue